import { NAME_MAX_LENGTH } from '@/features/master-table/utils';
import { t } from '@/i18n';
import { DateRangeSchema, DayjsSchema } from '@/utils';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

const snapShotStatus = z.enum(['success', 'processing', 'failure']);

export const SnapShotStatusLabelModifier = {
  success: t('snapshot.status-success'),
  processing: t('snapshot.status-processing'),
  failure: t('snapshot.status-failure'),
} as const satisfies Record<z.infer<typeof snapShotStatus>, string>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const SnapshotModel = z.object({
  id: z.string().uuid(),
  name: z.string(),
  referenceDate: z.string(),
  startYear: z.number().int().nullish(),
  endYear: z.number().int().nullish(),
  status: snapShotStatus,
});

export const SnapshotsModel = SnapshotModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

export const SnapshotFormSchema = z.object({
  name: z.string().max(NAME_MAX_LENGTH),
  referenceDate: DayjsSchema(),
  period: DateRangeSchema.nullish(),
});
